export default __webpack_public_path__ + "static/media/logo.c6a687d1.png";